import React from 'react'
// @ts-ignore
import Fade from 'react-reveal/Fade';
import { Image } from '../atoms/image'
import { Title } from '../atoms/title'

export const SystemView = () =>
  <section className="content">
    <section className="content--standard systemview">
      <Title>SYSTEM</Title>
      <section className="systemview--mainArea">
        <div className="systemview--mainArea--descriptionArea">
          <Fade left duration={500} delay={400} distance="40px">
            <h3 className="systemview--mainArea--descriptionArea__title">
              世界23カ国で、<br/>
              30,000件以上の治療実績。
            </h3>
          </Fade>
          <Fade left duration={500} delay={400} distance="40px">
            <p className="systemview--mainArea--descriptionArea__description">
              hanalove(はならぶ)は、「歯並びが整うことで、<br/>
              心も整い笑顔にする」ということを実現するために、<br/>
              患者様一人ひとりにあったマウスピースを製造し提供するアライナー矯正システムです。<br/>
              矯正専門医が治療計画の作成支援を実施。<br/>
              日本やシンガポールなどアジアを中心に、日本人の骨格や状態に合わせた30,000件以上の治療実績がございます。<br/>
            </p>
          </Fade>
        </div>
        <Fade left cascade duration={500} delay={400} distance="40px">
          <Image imageName="system.jpg" className="systemview--mainArea__image" />
        </Fade>
      </section>
    </section>
  </section>